import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Space, Typography, Tag, Popconfirm, Divider, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { updateBot } from '../../reducers/bots/resources';

const { Text } = Typography;
const { Option } = Select;

const SELECTIONS = [
    { value: 'send-message', label: 'Send message to bot' },
    { value: 'url', label: 'Go to URL' },
];

export default function PersistentMenu({ bot }) {
    const [items, setItems] = useState(bot?.persistent_menu || []);
    const [itemTitle, setItemTitle] = useState('');
    const [selection, setSelection] = useState('send-message');
    const [message, setMessage] = useState('');
    const [url, setUrl] = useState('');

    useEffect(() => {
        setItems(bot?.persistent_menu || []);
    }, [bot]);

    const persist = async (next) => {
        setItems(next);
        if (bot?.id) await updateBot(bot.id, { persistent_menu: next });
    };

    const handleCreate = async () => {
        if (!itemTitle.trim()) return;
        const next = [
            ...items,
            {
                item_title: itemTitle.trim(),
                selection,
                message: selection === 'send-message' ? message : '',
                url: selection === 'url' ? url : '',
                created_at: String(Date.now()),
            },
        ];
        await persist(next);
        setItemTitle('');
        setSelection('send-message');
        setMessage('');
        setUrl('');
    };

    const handleDelete = async (item) => {
        const next = items.filter((i) => i.created_at !== item.created_at);
        await persist(next);
    };

    return (
        <div>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>Persistent Menu</Text>
            {items.length === 0 && (
                <Text type="secondary" style={{ display: 'block', fontSize: 12, margin: '4px 0' }}>
                    No menu items yet
                </Text>
            )}
            <Space direction="vertical" style={{ width: '100%' }} size="small">
                {items.map((item) => (
                    <Card
                        key={item.created_at}
                        size="small"
                        extra={(
                            <Popconfirm
                                title="Delete this item?"
                                onConfirm={() => handleDelete(item)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="text" danger size="small" icon={<DeleteOutlined />} />
                            </Popconfirm>
                        )}
                        title={<Text strong style={{ fontSize: 13 }}>{item.item_title}</Text>}
                    >
                        <Tag color={item.selection === 'url' ? 'geekblue' : 'green'} style={{ fontSize: 11 }}>
                            {SELECTIONS.find((s) => s.value === item.selection)?.label || item.selection}
                        </Tag>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {item.selection === 'url' ? item.url : item.message}
                        </Text>
                    </Card>
                ))}
            </Space>

            <Divider style={{ margin: '12px 0' }} />

            <Space direction="vertical" style={{ width: '100%' }} size={8}>
                <Input
                    placeholder="Item title"
                    value={itemTitle}
                    onChange={(e) => setItemTitle(e.target.value)}
                />
                <Select value={selection} onChange={setSelection} style={{ width: '100%' }}>
                    {SELECTIONS.map((s) => (
                        <Option key={s.value} value={s.value}>{s.label}</Option>
                    ))}
                </Select>
                {selection === 'url' ? (
                    <Input
                        placeholder="https://…"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                    />
                ) : (
                    <Input
                        placeholder="Message to send"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                )}
                <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate} block>
                    Add item
                </Button>
            </Space>
        </div>
    );
}
